export default __webpack_public_path__ + "static/media/kitchen3-afterC-768w.b58a2454.webp";